module.exports = __webpack_public_path__ + "34de835a318ed35e9aef44df312444c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./web/images/faces/tokyo.jpg
// module id = 607
// module chunks = 0